import React from 'react';
import { browserHistory } from 'react-router';
import * as actions from '../../redux/actions';
import Api from '../../Api';
import ReactSpinner from 'react-spinjs';
import BaseLayout from './BaseLayout';

const DEFAULT_ACTION = '_empty_';

class KioskBatchActionPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      batchAction: DEFAULT_ACTION,
      responseText: '',
      inProgress: false,
    };
  }

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.getQueueActionData());
    window.scrollTo(0, 0);
  }

  handleBatchAction = () => {
    let { selectedHostInfoList } = this.props;
    let { batchAction } = this.state;

    let doAction = window.confirm(
      "Confirm applying '" + batchAction + "' to " + selectedHostInfoList.length + ' kiosks?'
    );
    if (!doAction) {
      return;
    }
    let {
      auth: { user },
    } = this.props;
    let createdBy = user.email;
    let kioskTasks = toKioskTasks(selectedHostInfoList, batchAction);

    this.setState({ inProgress: true });
    // console.log(createdBy, batchAction, kioskTasks);
    Api.sendQueueMessages(batchAction, createdBy, kioskTasks)
      .then((response) => {
        this.setState({ responseText: JSON.stringify(response, undefined, 2), inProgress: false });
      })
      .catch((e) => {
        this.setState({ responseText: e.message, inProgress: false });
        alert('Fail to send queue messages!');
      });
  };

  goBack = () => {
    let { prevLocation, queueActionData } = this.props;
    // if last location from login page, go to home page
    if (prevLocation && /^\/(login|logout)/.test(prevLocation.pathname)) {
      browserHistory.push('/');
      return;
    }
    browserHistory.goBack();
  };

  handleSelectedBatchActionChanged = (event) => {
    const target = event.target;
    const value = target.value;
    const oldValue = this.state.batchAction;

    this.setState(
      {
        batchAction: value,
      },
      () => {
        if (value !== oldValue) {
          this.setState({ responseText: '' });
        }
      }
    );
  };

  render() {
    let { selectedHostInfoList, queueActionData } = this.props;
    let { batchAction, inProgress, responseText } = this.state;
    let kioskTasks = toKioskTasks(selectedHostInfoList);
    let batchActionSelectList = toBatchActionSelectList(queueActionData);

    let disabled =
      batchAction === DEFAULT_ACTION || inProgress || !!responseText || kioskTasks.length === 0;
    return (
      <div className='kiosk-upgrade-page' style={{ fontSize: 14 }}>
        {inProgress && <ReactSpinner />}
        <div className='title-row user-title'>
          <div className='title-back cursor-pointer' onClick={this.goBack}>
            <i className='fa fa-chevron-left' />
          </div>
          <div className='title' style={{ paddingLeft: '10px', textAlign: 'center' }}>
            {batchAction === DEFAULT_ACTION ? 'Batch Action' : queueActionData[batchAction]}
          </div>
        </div>

        <div className='pure-g' style={{ marginBottom: 20 }}>
          {selectedHostInfoList.length > 0 && (
            <div
              className='pure-u-24-24'
              style={{
                margin: 20,
                background: 'white',
                padding: 10,
                borderTop: '5px solid #ccc',
                borderBottom: '5px solid #ccc',
              }}
            >
              <div
                style={{
                  borderBottom: '1px solid #aaa',
                  padding: 5,
                  fontWeight: 500,
                  marginBottom: 10,
                }}
              >
                <div className='pure-u-1-24'>#</div>
                <div className='pure-u-5-24'>Org</div>
                <div className='pure-u-5-24'>Location</div>
                <div className='pure-u-2-24'>Kiosk Name</div>
                <div className='pure-u-3-24'>IPAddress</div>
                <div className='pure-u-2-24'>TransQue Count</div>
                <div className='pure-u-2-24'>CCQuarantine Count</div>
                <div className='pure-u-2-24'>Print Jobs</div>
                <div className='pure-u-2-24'>Last Successful Fetched</div>
              </div>
              {selectedHostInfoList.map((info, index) => {
                return (
                  <div
                    key={info.id}
                    style={{
                      borderBottom:
                        index + 1 !== selectedHostInfoList.length ? '1px solid #ccc' : '0px',
                      padding: 5,
                    }}
                  >
                    <div className='pure-u-1-24'>{index + 1}</div>
                    <div className='pure-u-5-24'>{info.orgName}</div>
                    <div className='pure-u-5-24'>{info.locationName}</div>
                    <div className='pure-u-2-24'>{info.kioskName}</div>
                    <div className='pure-u-3-24'>{info.ip}</div>
                    <div className='pure-u-2-24'>{info.kskdbTransqueCount}</div>
                    <div className='pure-u-2-24'>{info.kskdbCCQuarantineCount}</div>
                    <div className='pure-u-2-24'>{info.cupsPendingPrintJobs}</div>
                    <div className='pure-u-2-24'>{info.lastFetchedXAgo}</div>
                  </div>
                );
              })}
            </div>
          )}

          <div className='pure-u-24-24' style={{ margin: 20 }}>
            <select
              className=''
              style={{ width: '100%', fontSize: 16 }}
              name='batchAction'
              value={batchAction}
              onChange={this.handleSelectedBatchActionChanged}
            >
              {batchActionSelectList.map((obj) => (
                <option key={obj.value} value={obj.value}>
                  {obj.label}
                </option>
              ))}
            </select>
          </div>

          {responseText && (
            <div className='pure-u-24-24' style={{ margin: '0 20px' }}>
              Result of queuing the actions/tasks:
              <pre
                style={{
                  background: 'white',
                  maxHeight: 300,
                  minHeight: 50,
                  overflow: 'auto',
                  padding: 10,
                  margin: '10px 0',
                  border: '1px solid #ccc',
                }}
              >
                {responseText}
              </pre>
              <div>
                Note that the tasks/actions are not processed right away and the tasks are queued to
                be processed later. Before user interface for the tasks status page is implemented,
                you need to query dashdb.kioskqueuetasklog table to see the result of the tasks if
                necessary.
              </div>
            </div>
          )}

          <div className='pure-u-8-24'></div>
          <div className='pure-u-6-24'>
            <button
              className='pure-button button-regular button-primary'
              onClick={this.handleBatchAction}
              disabled={disabled}
            >
              {inProgress ? (
                <i className='fa fa-refresh fa-spin' />
              ) : (
                <span>Apply to {kioskTasks.length} Kiosks</span>
              )}
            </button>
          </div>
          <div className='pure-u-8-24'></div>
        </div>
      </div>
    );
  }
}

function sortByOrgAndLoc(k1, k2) {
  let org1 = k1.orgName ? k1.orgName.toLowerCase() : '';
  let org2 = k2.orgName ? k2.orgName.toLowerCase() : '';
  let loc1 = k1.locationName ? k1.locationName.toLowerCase() : '';
  let loc2 = k2.locationName ? k2.locationName.toLowerCase() : '';
  if (org1 < org2) return -1;
  if (org1 > org2) return 1;
  if (loc1 < loc2) return 1;
  if (loc1 > loc2) return -1;
  return 0;
}

function toKioskTasks(selectedHostInfoList = [], actionName) {
  let sortedList = selectedHostInfoList.sort(sortByOrgAndLoc);
  return sortedList.map((hostInfo) => {
    return {
      actionName: actionName,
      kioskId: hostInfo.kioskId,
      kioskName: hostInfo.kioskName,
      kioskType: hostInfo.kioskType,
      ipaddr: hostInfo.ip,
      locationName: hostInfo.locationName,
      orgName: hostInfo.orgName,
    };
  });
}

function toBatchActionSelectList(queueActionData = {}) {
  let selectList = Object.keys(queueActionData).map((k) => {
    return {
      value: k,
      label: queueActionData[k],
    };
  });
  return [
    {
      value: DEFAULT_ACTION,
      label: '-Choose action-',
    },
    ...selectList.sort((o1, o2) => {
      if (o1.label > o2.label) return 1;
      if (o1.label < o2.label) return -1;
      return 0;
    }),
  ];
}

export default KioskBatchActionPage;



// WEBPACK FOOTER //
// ./src/components/pages/KioskBatchActionPage.js